<template>
	<section v-if="items.length" class="faq-section background-light">
		<div class="row row-header align-center">
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="(item, index) in items" :key="item.ID" class="faq-item">
					<collapse
						:header="item.question"
						:content="item.answer"
						:is-open="activeIndex === index"
						@click="toggleCollapse(index)"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const activeIndex = ref(null);

const toggleCollapse = (index) => {
	activeIndex.value = activeIndex.value === index ? null : index;
};
</script>

<style lang="scss" scoped>
.faq-section {
	margin-top: 40px;
	padding: 40px 0;
}

.faq-item {
	text-align: left;
}

.faq-row {
	margin-bottom: 30px;
}
</style>
